import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
        </div>

        <nav className="footer-nav" aria-label="Footer navigation">
          <Link to="/mentors" className="footer-link">Find Trainers</Link>
          <Link to="/signup" className="footer-link">Become a Trainer</Link>
          <Link to="/terms" className="footer-link">Terms of Service</Link>
        </nav>

        <p className="footer-copy">
          &copy; {year} GamePlannr LLC. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
